module.exports = __webpack_public_path__ + "static/media/gender-neutral-user.120d88a1.png";